Origin.$(document).on("click",".search-icon", function(){
	Origin.$("#search").toggleClass("enabled");
	if( Origin.$("#search").hasClass("enabled") ) {
		Origin.$(".search-text").focus();
	}
});
